var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57895 12.096L7.57895 23C7.57895 23.5523 8.02666 24 8.57895 24L15.4211 24C15.9733 24 16.4211 23.5523 16.4211 23L16.4211 12.096C16.4211 11.269 17.3677 10.7995 18.0261 11.2999L22.3949 14.6201C23.0533 15.1205 24 14.651 24 13.824L24 9.61603C24 9.30351 23.8539 9.00896 23.6051 8.81986L12.6051 0.459863C12.2475 0.188079 11.7525 0.188079 11.3949 0.459863L0.39492 8.81986C0.146104 9.00896 1.28481e-06 9.30351 1.25749e-06 9.61602L8.89616e-07 13.824C8.17319e-07 14.651 0.946673 15.1205 1.60509 14.6201L5.97387 11.2999C6.63228 10.7995 7.57895 11.269 7.57895 12.096Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.fc9ff94e.svg";
export { ForwardRef as ReactComponent };